import React from 'react';

const shimmer = 'bg-gray-200 animate-pulse rounded';

export const SkeletonLine: React.FC<{ className?: string }> = ({ className = 'h-4 w-full' }) => (
  <div className={`${shimmer} ${className}`} />
);

export const SkeletonCard: React.FC<{ lines?: number }> = ({ lines = 3 }) => (
  <div className="bg-white rounded-lg shadow p-6 space-y-3">
    <SkeletonLine className="h-5 w-2/3" />
    {Array.from({ length: lines - 1 }).map((_, i) => (
      <SkeletonLine key={i} className="h-4 w-full" />
    ))}
  </div>
);

export const SkeletonStatCards: React.FC<{ count?: number }> = ({ count = 3 }) => (
  <div className={`grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-${count} mb-8`}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-white rounded-lg shadow px-4 pt-5 pb-6 sm:px-6">
        <div className="flex items-center">
          <div className={`${shimmer} h-12 w-12 rounded-md`} />
          <div className="ml-4 flex-1 space-y-2">
            <SkeletonLine className="h-3 w-24" />
            <SkeletonLine className="h-6 w-16" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const SkeletonTable: React.FC<{ rows?: number; cols?: number }> = ({ rows = 5, cols = 5 }) => (
  <div className="bg-white rounded-lg shadow overflow-hidden">
    <div className="p-4 bg-gray-50 flex gap-4">
      {Array.from({ length: cols }).map((_, i) => (
        <SkeletonLine key={i} className="h-3 flex-1" />
      ))}
    </div>
    {Array.from({ length: rows }).map((_, rowIdx) => (
      <div key={rowIdx} className="px-4 py-3 flex gap-4 border-t border-gray-100">
        {Array.from({ length: cols }).map((_, colIdx) => (
          <SkeletonLine key={colIdx} className="h-4 flex-1" />
        ))}
      </div>
    ))}
  </div>
);
